/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
// delv/common/constants/bulktask/status.go
export enum BulkUploadTaskStatus {
  TaskNew = "New",
  TaskSubmitted = "Submitted",
  TaskEventSent = "EventSent",
  TaskPartiallySucceeded = "TaskPartiallySucceeded",
  TaskSucceeded = "Succeeded",
  TaskFailed = "Failed",
  TaskInvalid = "Invalid",
  TaskTimedOut = "TimedOut",
}

// https://config-portal.myteksi.net/#/config/cms-bulk-upload/features:UploadTypes/edit?group=grabtaxi
export enum UploadType {
  UpdateItemStock = "UpdateItemStock",
  UpdateMenuSingle = "Mex ItemV2",
  UpdateMenuGroup = "Mex MenuV2 ItemV2",
}

// delv/cms-bulk-upload/common/validation/constants.go
export enum FileValidationError {
  HeaderWrongColumnCount = " ERROR_FILE_HEADER_WRONG_COLUMN_COUNT",
  HeaderWrongHeaderName = "ERROR_FILE_HEADER_WRONG_HEADER_NAME",
  ExceededRowCount = "ERROR_FILE_EXCEEDED_ROW_COUNT",
  EmptyFile = "ERROR_FILE_EMPTY_FILE",
}

// delv/cms-bulk-upload/common/validation/constants.go
export enum RowValidationError {
  ColumnCountHigher = "ERROR_ROW_COLUMN_COUNT_HIGHER",
  ColumnCountLower = "ERROR_ROW_COLUMN_COUNT_LOWER",
}

export type BulkUploadTask = {
  taskID: string
  uploadType: UploadType
  status: BulkUploadTaskStatus
  uploadFileName: string
  submittedAt: number
  createdAt: number
  updatedAt: number
  errorReportURL: string
  merchantGroupID: string
  totalRowCount: number
  successRowCount: number
  errorRowCount: number
  statusCodes: {
    fileValidations: FileValidationError[]
    rowValidations: RowValidationError[]
  }
}

export type GetBulkUploadTaskRequest = {
  menuGroupID: string
  uploadType: UploadType
  limit: number
  startTime?: number
  endTime?: number
  startCursor?: string
  asc?: boolean
  status?: BulkUploadTaskStatus
}

export type GetBulkUploadTaskResponse = {
  tasks: BulkUploadTask[]
  nextCursor: string
}

export type CreateBulkTaskRequest = {
  fileName: string
  uploadType: UploadType
  merchantGroupID: string
  menuGroupID: string
}

export type CreateBulkTaskResponse = {
  taskID: string
  presignedURL: string
  headers: Array<{
    name: string
    value: string[]
  }>
}
export type CompleteBulkTaskRequest = {
  taskID: string
  uploadType: UploadType
  menuGroupID: string
}
